module.exports = __webpack_public_path__ + "img/rongyuzizhi-bg2.5e6cc18c.png";